module.exports = __webpack_public_path__ + "static/media/profile-img.5cd71a8a.png";